import { createSlice } from "@reduxjs/toolkit";

export const productsSlice = createSlice({
  name: "products",
  initialState: {
    items: [
      {
        id: 1,
        name: "Topi Kupluk",
        price: "Rp 100.000",
        image: "topikupluk.jpeg",
        category: "Pakaian Rajut",
        description:
          "Topi kupluk rajut handmade dengan bahan lembut, nyaman dipakai, dan tersedia dalam berbagai warna menarik.",
      },
      {
        id: 2,
        name: "Angkeb Deloan",
        price: "Rp 90.000",
        image: "angkeb.jpeg",
        category: "Tas Rajut",
        description:
          "Tas rajut handmade dengan desain unik dan kuat, cocok untuk aktivitas sehari-hari.",
      },
      {
        id: 3,
        name: "Syal",
        price: "Rp 150.000",
        image: "sial.jpeg",
        category: "Pakaian Rajut",
        description:
          "Syal rajut hangat dan lembut dengan sentuhan handmade yang elegan.",
      },
      {
        id: 4,
        name: "BH Top",
        price: "Rp 100.000",
        image: "bhtop.jpeg",
        category: "Pakaian Rajut",
        description:
          "BH top rajut handmade dengan desain sederhana, nyaman dipakai, dan mengikuti bentuk tubuh.",
      },
      {
        id: 5,
        name: "Tamler",
        price: "Rp 70.000",
        image: "tamler.jpeg",
        category: "Dekorasi Rajut",
        description:
          "Hiasan rajut handmade untuk mempercantik ruangan dengan kesan estetik dan natural.",
      },
      {
        id: 6,
        name: "Tas Selampang",
        price: "Rp 230.000",
        image: "tasselempang.jpeg",
        category: "Tas Rajut",
        description:
          "Tas selampang gede rajut handmade yang ringan, praktis, dan cocok untuk penggunaan sehari-hari.",
      },
      {
        id: 7,
        name: "Tas Selempang HP",
        price: "Rp 150.000",
        image: "tasselempanghp.jpeg",
        category: "Tas Rajut",
        description:
          "Tas rajut khusus HP dengan desain minimalis, aman, dan nyaman dibawa bepergian.",
      },
      {
        id: 8,
        name: "Dompet HP",
        price: "Rp 100.000",
        image: "dompethp.jpeg",
        category: "Aksesoris Rajut",
        description:
          "Dompet HP rajut handmade yang praktis untuk melindungi ponsel dari goresan.",
      },
      {
        id: 9,
        name: "Tas Mama",
        price: "Rp 230.000",
        image: "tasmama.jpeg",
        category: "Tas Rajut",
        description:
          "Tas rajut berukuran besar dengan desain elegan, cocok untuk kebutuhan sehari-hari.",
      },
      {
        id: 10,
        name: "Tas HP",
        price: "Rp 85.000",
        image: "tashp.jpeg",
        category: "Tas Rajut",
        description:
          "Tas HP rajut handmade yang ringan dan stylish untuk aktivitas santai.",
      },
      {
        id: 11,
        name: "Tas Gendong",
        price: "Rp 230.000",
        image: "tasgendong.jpeg",
        category: "Tas Rajut",
        description:
          "Tas gendong rajut handmade dengan kapasitas besar dan desain yang nyaman digunakan.",
      },
      {
        id: 12,
        name: "Topi Payung",
        price: "Rp 100.000",
        image: "topipayung.jpeg",
        category: "Pakaian Rajut",
        description:
          "Topi rajut handmade dengan desain unik menyerupai payung, cocok untuk gaya santai.",
      },
      {
        id: 13,
        name: "Tas Tenteng Bunga",
        price: "Rp 200.000",
        image: "tastenteng.jpeg",
        category: "Tas Rajut",
        description:
          "Tas tenteng rajut handmade dengan motif bunga yang cantik dan feminin.",
      },
    ],
    selectedCategory: "Semua",
  },
  reducers: {
    setSelectedCategory: (state, action) => {
      state.selectedCategory = action.payload;
    },
  },
});
